const ProcessStepData01 = [
  {
    icon: "line-icon-Idea-5",
    title: "Apply Online",
    content: "Fill out our simple franchise inquiry form",
  },
  {
    icon: "line-icon-Fountain-Pen",
    title: "Discussion & Approval",
    content:
      "Our team will connect with you to understand your goals and finalize details",
  },
  {
    icon: "line-icon-Loading-2",
    title: "Setup & Training",
    content:
      "We help with location setup, staff training, and supply chain support",
  },
  {
    icon: "line-icon-Juice",
    title: "Grand Opening",
    content:
      "Launch your own Mukhiya Ji Chai Café and start serving customers from day one",
  },
];

const ProcessStepData02 = [
  {
    title: "Project research",
    content: "Lorem ipsum amet consectetur do eiusmod tempor incididunt",
  },
  {
    title: "Sketches and design",
    content: "Lorem ipsum amet consectetur do eiusmod tempor incididunt",
  },
  {
    title: "Seleted concept",
    content: "Lorem ipsum amet consectetur do eiusmod tempor incididunt",
  },
];

const ProcessStepData03 = [
  {
    title: "RESEARCH",
    content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
  },
  {
    title: "SKETCHES",
    content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
  },
  {
    title: "CONCEPT",
    content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
  },
  {
    title: "PRESENTATION",
    content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
  },
];

const ProcessStepData04 = [
  {
    title: "RESEARCH PROJECT",
    content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
  },
  {
    title: "FIND PROBLEM",
    content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
  },
  {
    title: "START OPTIMIZE",
    content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
  },
  {
    title: "REACH TARGET",
    content: "Lorem ipsum dolor consectetur adipiscing eiusmod tempor",
  },
];

const ProcessStepData05 = [
  {
    title: "Start market research",
    content:
      "Lorem ipsum is simply text of the printing and typesetting industry lorem ipsum",
  },
  {
    title: "Discussion of the idea",
    content:
      "Lorem ipsum is simply text of the printing and typesetting industry lorem ipsum",
  },
  {
    title: "Production planning",
    content:
      "Lorem ipsum is simply text of the printing and typesetting industry lorem ipsum",
  },
];

const ProcessStepData06 = [
  {
    title: "Innovative business",
    content: "Easy to customize",
  },
  {
    title: "Expertly marketing",
    content: "High quality services",
  },
  {
    title: "Engaging audiences",
    content: "Build perfect websites",
  },
];

export {
  ProcessStepData01,
  ProcessStepData02,
  ProcessStepData03,
  ProcessStepData04,
  ProcessStepData05,
  ProcessStepData06,
};
